import { render, staticRenderFns } from "./MteTypeEdit.vue?vue&type=template&id=5cf3d3c3&scoped=true"
import script from "./MteTypeEdit.vue?vue&type=script&lang=js"
export * from "./MteTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./MteTypeEdit.vue?vue&type=style&index=0&id=5cf3d3c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3d3c3",
  null
  
)

export default component.exports